var $class="se2--country-selector-base",$name="countrySelectorBase",$path="app/partials/countrySelectorBase/config.js",$this={$class,$name,$path,};// eslint-disable-next-line import/prefer-default-export
export const countryListSelector = $class;
